import pool from '../data/generatedTestPool.json';

const DEFAULT_MIN = 5;
const DEFAULT_MAX = 15;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const getRandomInt = (min, max) => {
  const lower = Math.ceil(min);
  const upper = Math.floor(max);
  if (upper <= lower) {
    return lower;
  }
  return Math.floor(Math.random() * (upper - lower + 1)) + lower;
};

const hasLeadingQuantity = (text) => /^\s*\d+/.test(text);

const formatLine = (entry) => {
  if (!entry || typeof entry !== 'object') {
    return '';
  }
  const base = String(entry.line || entry.variant || entry.source_name || '').trim();
  if (!base) {
    return '';
  }

  if (hasLeadingQuantity(base)) {
    return base;
  }

  const qty = Number.isFinite(entry.quantity) ? Math.max(1, Math.round(entry.quantity)) : null;
  const quantity = qty ?? getRandomInt(1, 10);
  return `${quantity}x ${base}`.replace(/\s+/g, ' ').trim();
};

export const getRandomDemandLines = (min = DEFAULT_MIN, max = DEFAULT_MAX) => {
  if (!Array.isArray(pool) || pool.length === 0) {
    return [];
  }

  const normalizedMin = clamp(min, 1, pool.length);
  const normalizedMax = clamp(max, normalizedMin, pool.length);
  const count = getRandomInt(normalizedMin, normalizedMax);

  const picked = new Set();
  while (picked.size < count) {
    picked.add(getRandomInt(0, pool.length - 1));
  }

  return Array.from(picked)
    .map((index) => formatLine(pool[index]))
    .filter((line) => line);
};

export const getTestPoolSize = () => (Array.isArray(pool) ? pool.length : 0);

export default pool;
